import { TJoints } from '@/src/types/Common';

const additonalJoints: TJoints[] = ['lower_leg', 'wrist', 'elbow', 'foot'];
const oGJoints: TJoints[] = ['hip', 'knee', 'lower_back', 'hand', 'shoulder', 'neck'];

export const isJoint = (seekHelpFor?: string) => seekHelpFor
  && (additonalJoints.includes(seekHelpFor as TJoints) || oGJoints.includes(seekHelpFor as TJoints));
